import React from "react";

import { Module } from "@com.mgmtp.a12.client/client-core/lib/core/application";
import { View } from "@com.mgmtp.a12.client/client-core/lib/core/view";

import { FileDialog } from "./components/FileDialog";
import { importFileContentSaga } from "./sagas/importFileContentSaga";
import { readFileSaga } from "./sagas/readFileSaga";

const xmlEinlesenModule = (): Module => ({
	id: "modul25xmlEinlesenModule",
	views: () => viewComponentProvider,
	sagas: () => [readFileSaga, importFileContentSaga]
});

const components: Record<string, React.ComponentType<View> | undefined> = {
	XmlFileUpload: FileDialog
};

function viewComponentProvider(name: string): React.ComponentType<View> | undefined {
	return components[name];
}

export default xmlEinlesenModule;
